module.exports = __webpack_public_path__ + "media/images/ic_consigne-83d50985.svg";